import parsedQueryModule from '@/parsed-query/module.js';

export default parsedQueryModule.extend({
    duck: {
        store: 'query',
    },
});
